import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../Context/UserContext";
import { jwtDecode } from 'jwt-decode';
import { clearToken, isImpersonating } from "../../utils/authToken";
import { PiNotebook } from "react-icons/pi";

export default function MobileNavbar({ toggleSidebar }) {
    const { Authorization, setAuthorization } = useContext(UserContext);
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const userRole = Authorization ? jwtDecode(Authorization).role : null;
    const isAdmin =
        !isImpersonating() &&
        (userRole === "admin" || localStorage.getItem("isAdmin") === "true");

    function LogOut() {
        clearToken();
        setAuthorization(null);
        navigate("/");
    }

    return (
        <nav className="main-navbar " >
            <div className="navbar-inner">
               <PiNotebook 
        className="notebook-icon" 
        onClick={toggleSidebar} 
        style={{ cursor: "pointer", fontSize: "24px" }} 
      />
                <div className="navbar-logo">
                    {/* <img src={logo} alt="Logo" className="navbar-logo-img" /> */}
                    <span className="navbar-title" style={{color:"#005f4b"}}>MAZRAA ONLINE</span>
                </div>

             

          
            </div>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="mobile-menu">
                    <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
                    {/* <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</Link> */}
                    <Link to="/homeServices" onClick={() => setMobileMenuOpen(false)}>Services</Link>
                    {isAdmin && (
                        <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
                    )}
                    <div className="mobile-auth-buttons">
                        {Authorization ? (
                            <button onClick={() => { LogOut(); setMobileMenuOpen(false); }} className="navbar-login-btn">Logout</button>
                        ) : (
                            <>
                                <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="navbar-login-btn">Sign in</Link>
                                <Link to="/register" onClick={() => setMobileMenuOpen(false)} className="navbar-signup-btn">Sign up</Link>
                            </>
                        )}
                    </div>
          
                </div>
            )}
        </nav>
    );
}